import React, { useState } from 'react';

import { useReferrerAppDispatch } from 'shared/hooks/useReferrerAppDispatch';
import { requestPhoneValidationCode } from 'shared/thunks/referrer/requestPhoneValidationCode/requestPhoneValidationCode';
import { sendCodeAndAddPhone } from 'shared/thunks/referrer/sendCodeAndAddPhone/sendCodeAndAddPhone';

import { SendVerificationCodeModalContent } from '../../../components/Modals';
import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { selectPageModal, selectUserPhone } from '../../../selectors';
import { useGetReferralLink } from '../Hero/hooks/useGetReferralLink';
import { useCountDown } from './useCountDown/useCountDown';
import { formatPhoneStringToClient } from '../../../utils/formatPhoneString';

export const SendVerificationCodeModal: React.FC = () => {
  const dispatch = useReferrerAppDispatch();
  const { shareReferralLink, copyReferralLink } = useGetReferralLink();
  const { seconds: countDown, showRepeatButton, start: startCountDown } = useCountDown();

  const phone = useSelector(selectUserPhone) as string; // На этом этапе точно есть номер
  const { action, error } = useSelector(selectPageModal);
  const onSuccess = action === 'copy' ? copyReferralLink : shareReferralLink;

  const [code, setCode] = useState('');
  const isCodeEmpty = code.length === 0;

  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  const handleCodeChange = React.useCallback((value: string) => {
    setCode(value);
  }, []);

  const handleSendCodeClick = React.useCallback(async () => {
    dispatch(
      sendCodeAndAddPhone({
        phone,
        code,
        onSuccess,
      }),
    );
  }, [dispatch, code]);

  const handleRepeatButtonClick = React.useCallback(() => {
    startCountDown(60);
    setCode('');
    dispatch(requestPhoneValidationCode(phone));
  }, [dispatch, phone]);

  return (
    <SendVerificationCodeModalContent
      isPhone={isPhone}
      showRepeatButton={showRepeatButton}
      phone={formatPhoneStringToClient(phone)}
      code={code}
      error={error}
      isDisable={isCodeEmpty}
      countDown={countDown}
      onCodeChange={handleCodeChange}
      onSendCodeClick={handleSendCodeClick}
      onRepeatButtonClick={handleRepeatButtonClick}
    />
  );
};
